module.exports = __webpack_public_path__ + "assets/home-active.eee8d3cd.svg";